<script lang="ts">export let size = 24;
const height = size;
</script>

<svg {height} style="fill: currentColor" viewBox="0 0 30 16" xmlns="http://www.w3.org/2000/svg">
	<path
		clip-rule="evenodd"
		d="M4 0C1.79086 0 0 1.79086 0 4V12C0 14.2091 1.79086 16 4 16H26C28.2091 16 30 14.2091 30 12V4C30 1.79086 28.2091 0 26 0H4ZM2 4C2 2.8954 2.89543 2 4 2H26C27.1046 2 28 2.8954 28 4V12C28 13.1046 27.1046 14 26 14H4C2.89543 14 2 13.1046 2 12V4ZM6.888 5.4H5V11H9.416V9.536H6.888V5.4ZM12.4655 5.4H10.5775V11H12.4655V5.4ZM19.9984 5.4L17.6304 11H15.7744L13.4064 5.4H15.4384L16.7744 8.672L18.1424 5.4H19.9984ZM25.4823 11V9.576H22.6822V8.84H25.0502V7.48H22.6822V6.824H25.3783V5.4H20.8263V11H25.4823Z"
		fill-rule="evenodd"
	/>
</svg>
